import(/* webpackMode: "eager" */ "/home/tourta5/apps/tourtask/releases/20261104_100839_c469b6072bd7/apps/backoffice/src/app/global-error.tsx");
